"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getInvitationToken = async () => {
  const api = "".concat(process.env.REACT_APP_PATH, "/Micado.WebEngine/Micado.WebEngine.Plugin.InternalUser/GetInvitationToken.api");
  const headers = {};
  const loginToken = localStorage.getItem("logintoken");
  if (loginToken) {
    headers.Authorization = "Bearer ".concat(loginToken);
  }
  try {
    const response = await fetch(api, {
      method: "GET",
      headers
    });
    return await response.json();
  } catch (error) {
    return {
      success: false
    };
  }
};
var _default = exports.default = getInvitationToken;